import { RefObject } from "react";
import { DeviceType, IUISettings, IUser } from "../interfaces/App";
import parse from 'html-react-parser';

export const parseResponse = (res: any): string => {
    if (res.type.indexOf("_SUCCESS") > -1) {
        return undefined;
    }
    return res.error.response.data.msg ? res.error.response.data.msg : res.error.message;
};
export function detectUI(width: number, height: number, containerRef: RefObject<HTMLDivElement>): IUISettings {
    const deviceType = (width < DeviceLimits.small ? DeviceType.small : (width < DeviceLimits.medium ? DeviceType.medium : DeviceType.large));
    return {
        isMobile: isMobile(),
        deviceType,
        width,
        height,
        portrait: height > width,
        containerHeight: containerRef?.current?.offsetHeight,
        containerTop: containerRef?.current?.offsetTop,
    };
};
export function isMobile(): boolean {
    return window.matchMedia("(max-width: 768px)").matches;
};
export function cleanURL(url: string): string {
    // const serverUrl = url.replace(/[^/]*$/, "").replace(/\/#\//, "");
    return url.replace(/#.+$/, "").replace(/(\.[^/]+).*$/, (_a: string, b: string) => {return b});
};

const DeviceLimits = {
    small: 400,
    medium: 800,
};

export const setValidatedStorageItem = (name: string, value: string) => {
    if (value && value !== "undefined" && value !== "none" && value !== "null") {
        // console.log("setValidatedStorageItem:", name,  value);
        localStorage.setItem(name, value);
    }
};

export const parseImageIndexHtml = (index: string) => {
    const res: any = parse(index);
    if (res.type === 'html' && res.props.children.type === "body") {
        console.log(res.props.children.props.children);
    }
    console.log(res);
    return res;
};

export const checkRights = (user: IUser, path?: string): boolean => {
    const idx = user.rights?.split(",").findIndex((r: string) => r === path);
    return (user.rights && (user.rights === "AVATAR" || idx > -1)) ? true : false;
};

// export const redirect = (key: string) => {
//     if (document.location.href.indexOf( key + "=") > -1) {
//         const token = document.location.href.replace(/^.+#\/token=(.+)/, "$1");
//         const baseUrl = document.location.href.replace(/^(.+)#\/token=.+/, "$1");
//         setValidatedStorageItem("AUTHTOKEN", token);
//         const url = baseUrl + "#welcome";
//         document.location.href = url;
//     }
// };

export const formatDateTime = (date: Date, format: string): string => {
    return format.replace(/mm/, String(date.getMonth() + 1)).replace(/dd/, String(date.getDate()));
};